<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
        <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
            <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">2</span>
        </div>
        <span class="flex flex-1 text-700 font-medium xl:text-xl">
            {{ content[lang_].header }} {{ setUppercase(bank_code) }}
        </span>
    </div>
    <div class="w-full flex flex-column xl:flex-row relative">
        <div class="w-full flex flex-column max-w-30rem relative
            surface-0 xl:surface-100 lg:surface-100 md:surface-100
            border-round-2xl 
            p-3 xl:p-4 mb-1 xl:mb-5">
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].amount }}:
            </span>
            <span v-if="amount && currency" class="flex text-lg md:text-lg lg:text-lg xl:text-xl font-semibold text-900 mb-3 xl:mb-4">
                <span>{{ get_format_amount(amount, currency) }}</span>
            </span>
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].wallet_address }}:
            </span>
            <span class="flex text-xs md:text-base lg:text-base xl:text-md font-semibold text-900 mb-2 xl:mb-3">
                <span>{{ wallet_address }}</span>
            </span>
            <Button v-if="wallet_network" class="mb-3 border-round-xl text-sm border-2" severity="secondary" outlined icon="pi pi-copy"
                :label="content[lang_].copy"  @click="copy(wallet_address)" />
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].wallet_network }}:
            </span>
            <span class="flex text-sm xl:text-lg font-medium text-900 xl:mb-4">
                <span>{{ getWalletNetworkTitle(wallet_network, lang_) }}</span>
            </span>
            <div v-if="bank_image" class="absolute flex right-0 bottom-0 surface-0 mr-3 mb-3 deep_white_shadow border-circle align-items-center justify-content-center text-center">
                <Avatar :image="bank_image" size="medium" shape="circle" class="flex" />
            </div>
        </div>

        <div class="w-full flex flex-column max-w-30rem gap-2 relative py-1 xl:py-0 xl:px-8">
            <InlineMessage severity="success" class="border-round-2xl line-height-2 text-sm xl:text-md border-none">
                {{ content[lang_].make_sure_1 }} 
            </InlineMessage>
            <InlineMessage severity="warn" class="border-round-2xl line-height-2 text-sm xl:text-md border-none">
                {{ content[lang_].make_sure_2 }} 
            </InlineMessage>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper'
export default {
    props: [
        'bank_code',
        'bank_image',
        'amount',
        'currency',
        'wallet_address',
        'wallet_network'
    ],
	data(){
		return{
			content: {
				en: {
					header: 'As payment, make a transfer by details to the account ',
                    amount: 'Amount',
                    wallet_address: 'Wallet Address',
                    wallet_network: 'Network',
                    copy: 'Copy',
                    copied: 'Copied',
                    make_sure_1: 'Pay the transfer by transferring USDT to the wallet address in the correct network',
                    make_sure_2: 'Attention! Be sure to send the exact amount up to 2 decimal places. Otherwise, the funds may not reach or be credited.'
				} ,
				ru: {
					header: 'В качестве оплаты совершите перевод по реквизитам на аккаунт ',
                    amount: 'Сумма',
                    wallet_address: 'Адрес кошелька',
                    wallet_network: 'Сеть',
                    copy: 'Скопировать',
                    copied: 'Скопировано',
                    make_sure_1: 'Оплатите трансфер переводом USDT по адресу кошелька в правильной сети',
                    make_sure_2: 'Внимание! Обязательно отправляйте точную сумму до 2 знаков после запятой. В противном случае, средства могут не дойти или не засчитаться.'
				},
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        get_format_amount(value, currency) {
            let digits = 2
            if(currency=='rub' || currency=='idr') digits = 0
            return this.helper.format_amount(value, currency, digits)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: text, life: 1000 })
        },
        setUppercase(text){
            if(!text) return ''
            return text.toUpperCase()
        },
        getWalletNetworkTitle(network){
            if(!network) return '-'
            return this.helper.getWalletNetworkTitle(network)
        }
	},
	beforeCreate() {
        this.helper = new Helper()    
	}
}
</script>